import React from 'react';
import styled from 'styled-components';
import { useField, useFormikContext } from 'formik';

import InputHeader from '../InputHeader';
import { StyledInputContainer, InputStyles } from '../styled';

import { IGenderSwitch, GenderEnum } from './types';
import GenderIcon from './components/GenderIcon';

const getNextValue = (value: GenderEnum) => {
  switch (value) {
    case GenderEnum.UNKNOWN:
      return GenderEnum.MALE;
    case GenderEnum.MALE:
      return GenderEnum.FEMALE;
    case GenderEnum.FEMALE:
      return GenderEnum.UNKNOWN;
    default:
      return GenderEnum.UNKNOWN;
  }
};

const GenderSwitch: React.FC<IGenderSwitch> = props => {
  const { className, name, header = '', prependIcon } = props;

  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  const { value, onChange } = field;

  const clickHandler = () => {
    const next = getNextValue(value);
    setFieldValue(name, next);
    onChange(next);
  };

  return (
    <StyledInputContainer>
      <InputHeader text={header} prependIcon={prependIcon} />
      <StyledGenderSwitch className={className} onClick={clickHandler}>
        <GenderIcon type={field.value} />
      </StyledGenderSwitch>
    </StyledInputContainer>
  );
};

export const StyledGenderSwitch = styled.div`
  ${InputStyles.Base}
  ${InputStyles.Normal}
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 48px;
  width: 42px;
`;

export default GenderSwitch;
